<template>
  <v-layout column fill-height>
    <v-flex style="position: relative;">
      <div
        class="wrapper py-12 px-xl-10 px-md-4 px-xs-1 grey lighten-3"
        style="position: absolute; top: 0px; left: 0; right: 0; bottom: 0; overflow: auto;"
      >
        <div
          class="webpage-viewer white"
          ref="wrapper"
          :style="`height: ${docHeight}; position: relative;`"
        >
          <div v-if="loadingSrc">
            <v-skeleton-loader
              class=""
              type="card-avatar, divider, list-item-three-line, divider, card-heading, article, actions"
            ></v-skeleton-loader>
          </div>
          <v-row
            v-else-if="fetchingSrc"
            align-content="center"
            justify="center"
            class="pa-12"
            no-gutters
          >
            <v-col cols="12" style="text-align: center;" class="py-6">
              <span class="title">Fetching and Saving Webpage</span>
            </v-col>
            <v-col cols="12">
              <v-card style="margin-left: auto; margin-right: auto;" width="400">
                <v-skeleton-loader class="" type="image, divider, article"></v-skeleton-loader>
                <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
              </v-card>
            </v-col>
          </v-row>
          <template v-else-if="filePath">
            <v-btn
              v-if="addBtn.show"
              @click="saveExcerpt"
              color="blue lighten-1"
              :style="`position: absolute; left: ${addBtn.left}px; top: ${addBtn.top}px;`"
              >CAPTURE</v-btn
            >
            <v-btn
              v-if="captureSelection.showBtn"
              :loading="!captureSelection.imageUrl"
              @click="saveScreen"
              color="blue lighten-1"
              :style="
                `position: absolute; left: ${captureSelection.position.minX +
                  captureSelection.position.width / 2}px; top: ${captureSelection.position.minY +
                  captureSelection.position.height +
                  10}px; z-index: 2; margin-left: -100px;`
              "
              >CAPTURE</v-btn
            >
            <iframe
              ref="sourceFrame"
              :srcdoc="filePath"
              @load="iframeLoaded = true"
              style="width: 100%; height: 100%;"
            ></iframe>
            <screen-capture-omatic
              v-if="iframeLoaded"
              v-show="screenCaptureMode"
              :active="screenCaptureMode"
              :target="getCaptureTarget()"
              @selection="$emit('updateCaptureSelection', $event)"
              @imageReady="
                $emit('updateCaptureSelection', { ...captureSelection, imageUrl: $event })
              "
            ></screen-capture-omatic>
          </template>
          <v-row v-else align-content="center" justify="center" class="pa-12" no-gutters>
            <v-col cols="12" style="text-align: center;" class="py-6">
              <span class="title">Dang, had trouble capturing that webpage.</span>
            </v-col>
            <v-col cols="12" style="text-align: center;">
              <v-btn large @click="updateSource" color="primary">Try again</v-btn>
            </v-col>
            <v-col cols="12 pt-4" style="text-align: center;">
              or try the
              <a
                href="https://chrome.google.com/webstore/detail/context-resource-clipper/jhjceeelmdngbknpihnjmeocgjckaodl"
                target="_blank"
                >Context Web Clipper</a
              >
            </v-col>
          </v-row>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import fb from '@/firebaseConfig';
import findAndReplaceDomText from 'findandreplacedomtext';
import ScreenCaptureOmatic from './ScreenCaptureOmatic';

import { mapActions } from 'vuex';

export default {
  props: ['resource', 'screenCaptureMode', 'captureSelection'],
  components: { ScreenCaptureOmatic },
  data() {
    return {
      fetching: false,
      loadingSrc: true,
      iframeLoaded: false,
      filePath: false,
      docHeight: '100%',
      addBtn: {
        show: false,
        test: '',
        left: null,
        right: null
      }
    };
  },
  mounted() {
    console.log('get file path');
    this.getFilePath();
  },
  watch: {
    resource: {
      deep: true,
      handler() {
        this.getFilePath();
        this.iframeLoaded = false;
        // console.log(n, o);
        // if (n.noteBlocks != o.noteBlocks) {
        //   this.setHighlight(Object.values(n.noteBlocks));
        // }
      }
    },
    iframeLoaded: function(n) {
      if (n) {
        this.$nextTick(() => {
          const iframe = this.$refs.sourceFrame;
          const doc = iframe.contentWindow.document;

          //  set the height of the iframe wrapper to encompass the content
          const docHeight = doc.body.clientHeight;
          this.docHeight = docHeight + 45 + 'px';

          // turn on highlight style

          const style = document.createElement('style');
          style.innerHTML =
            '.context-highlight.light {' +
            'background-color: lightyellow;' +
            '}' +
            '.context-highlight.dark {' +
            'background-color: yellow;' +
            '}';
          const selector = doc.querySelector('style');
          if (selector != null) {
            selector.parentNode.insertBefore(style, selector);
          } else {
            doc.querySelector('header').appendChild(style);
          }
          this.setHighlight(this.filteredResources);

          //  Add selection listen events

          const toggleExcerptBtn = () => {
            const selection = doc.getSelection();
            console.log('mouse up', selection);
            if (selection.rangeCount > 0 && selection.toString().length > 0) {
              console.log(selection, selection.toString());
              const getRange = selection.getRangeAt(0);
              const getRect = getRange.getBoundingClientRect();
              const left = getRect.left + getRect.width / 2 - 30;
              const top = getRect.bottom + 10;
              this.addBtn = {
                show: true,
                left: left,
                top: top,
                text: selection.toString()
              };
            } else {
              this.addBtn.show = false;
              this.addBtn.text = '';
            }
          };
          doc.addEventListener('click', toggleExcerptBtn);

          //  copy listener
          doc.addEventListener('keydown', ev => {
            console.log(ev);
            if (ev.keyCode == 67 && ev.ctrlKey) {
              if (doc.getSelection().rangeCount) {
                console.log('save excerpt');
                this.saveExcerpt();
              }
            }
          });

          doc.addEventListener('mousedown', () => {
            this.addBtn.show = false;
            this.addBtn.text = '';
          });
          doc.addEventListener('mouseup', () => {
            setTimeout(() => {
              console.log('mouseup');
              const selection = doc.getSelection();
              if (!selection.rangeCount) {
                this.addBtn.show = false;
                this.addBtn.text = '';
              }
            }, 10);
          });
        });
      }
    }
  },
  computed: {
    filteredResources() {
      return Object.values(this.resource.noteBlocks).filter(n => !n.toDelete);
    }
  },
  methods: {
    ...mapActions('resources', ['addExcerpt', 'addScreenShotExcerpt', 'updateResourceSource']),
    updateSource() {
      this.fetching = true;
      this.updateResourceSource({ resource: this.resource }).then(() => {
        this.getFilePath();
        this.fetching = false;
      });
    },
    getCaptureTarget() {
      const iframe = this.$refs.sourceFrame;
      const doc = iframe.contentWindow.document;
      return doc.querySelector('body');
    },
    async getFilePath() {
      console.log('get file path');
      this.loadingSrc = true;
      let url;
      try {
        const ref = this.resource.resourceData.webpageHtmlRef;
        if (ref) {
          if (ref == 'fetching') {
            this.fetchingSrc = true;
          } else {
            console.log('ref');
            const fbFileRef = fb.storage.ref().child(ref);
            url = await fbFileRef.getDownloadURL();
            const response = await fetch(url);
            this.filePath = await response.text();
            this.fetchingSrc = false;
            this.$emit('ready');
          }
          //this.filePath = require(url);
        } else {
          console.log('no ref');
          url = '';
          this.loadingSrc = false;
          this.filePath = false;
        }
      } catch (e) {
        console.log(e);
        url = false;
      }

      this.loadingSrc = false;
      //this.filePath = url;
    },
    saveExcerpt() {
      const excerpt = this.addBtn.text;
      //  Get html body
      const iframe = this.$refs.sourceFrame;
      const doc = iframe.contentWindow.document;
      const allText = doc.body.innerText;
      const position = allText.indexOf(excerpt);
      const order = allText.indexOf(excerpt);
      if (excerpt.length) {
        this.$emit('saveExcerpt', {
          resourceId: this.resource.id,
          excerpt,
          source: 'webpageModule',
          position,
          order,
          callback: () => {
            console.log('call back!');
            this.setHighlight(this.filteredResources);
            this.addBtn.show = false;
            this.addBtn.text = '';
          }
        });
        // this.addExcerpt({
        //   resourceId: this.resource.id,
        //   excerpt,
        //   source: 'webpageModule',
        //   position,
        //   order
        // })
        //   .then(clipId => {
        //     //  add to c
        //     this.$emit('addedExcerpt', { clipId, excerpt, resourceId: this.resource.id });
        //     this.$nextTick(() => {
        //       this.setHighlight(this.filteredResources);
        //     });
        //   })
        //   .catch(e => {
        //     console.log('error saving excerpt', e);
        //   })
        //   .finally(() => {
        //     this.addBtn.show = false;
        //     this.addBtn.text = '';
        //   });
      }
    },
    saveScreen() {
      const excerptData = {
        imageUrl: this.captureSelection.imageUrl,
        position: this.captureSelection.position
      };
      this.$emit('saveScreen', {
        resourceId: this.resource.id,
        excerptData,
        source: 'webpageModule',
        callback: () => {
          this.$emit('updateCaptureSelection', {
            showBtn: false,
            imageUrl: false,
            position: {}
          });
          this.$emit('updateScreenCaptureMode', false);
        }
      });
      // this.addScreenShotExcerpt({
      //   resourceId: this.resource.id,
      //   excerptData,
      //   source: 'webpageModule'
      // })
      //   .then(clipId => {
      //     console.log('copy addedExcerpt');
      //     this.$emit('addedExcerpt', {
      //       clipId,
      //       excerpt: 'Screen Capture',
      //       resourceId: this.resource.id
      //     });
      //     this.$emit('updateCaptureSelection', {
      //       showBtn: false,
      //       imageUrl: false,
      //       position: {}
      //     });
      //   })
      //   .catch(e => console.log(e));
      // this.$emit('updateScreenCaptureMode', false);
    },
    scrollContent(id) {
      const iframe = this.$refs.sourceFrame;
      const doc = iframe.contentWindow.document;
      console.log(`.excerpt-${id}`);
      const target = doc.querySelector(`.excerpt-${id}`);
      if (target) {
        const top = target.getBoundingClientRect().top;
        this.$emit('scrollTo', top);
      }
    },
    removeHighlight(id) {
      console.log('remove');
      const iframe = this.$refs.sourceFrame;
      const doc = iframe.contentWindow.document;
      const target = doc.querySelector(`.excerpt-${id}`);
      if (target) {
        console.log(target);
        target.classList.remove(`excerpt-${id}`);
        target.classList.remove(`context-highlight`);
        target.classList.remove(`light`);
      }
    },
    setHighlight(excerpts) {
      const iframe = this.$refs.sourceFrame;
      const doc = iframe.contentWindow.document;
      excerpts.forEach(e => {
        const classId = 'excerpt-' + e.id;
        const elementsOfInterest = doc.getElementsByClassName(classId);
        if (elementsOfInterest.length === 0) {
          const { widgetData } = e.content;
          if (e.content.widgetType != 'textExcerpt') {
            return;
          }
          const text = widgetData.excerpt;
          //remove carriage returns
          const newString = text.replace(/\n/g, '').replace(/\r/g, '');
          findAndReplaceDomText(doc, {
            find: newString,
            wrap: 'highlight',
            wrapClass: `context-highlight light ` + classId
          });
        }
      });
    }
  }
};
</script>

<style></style>
